import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationGroupMemberEntity } from './notification-group-member.entity';
import { PhoneTopicEntity } from './phone-topic.entity';
import { PhoneEntity } from './phone.entity';

@Index('_fk__phone_topic__id', ['fkPhoneTopicId'], {})
@Index('unique_phone', ['fkPhoneId', 'fkPhoneTopicId'], { unique: true })
@Entity('_phone__phone_topic')
export class PhonePhoneTopicEntity extends BaseEntity {
	@Column('int', { name: '_fk__phone__id', unsigned: true })
	public fkPhoneId!: number;

	@Column('int', { name: '_fk__phone_topic__id', unsigned: true })
	public fkPhoneTopicId!: number;

	@Column('datetime', { name: '_opt_in', nullable: true })
	public optIn!: Date | null;

	@Column('datetime', { name: '_opt_out', nullable: true })
	public optOut!: Date | null;

	@Column('datetime', { name: '_opt_in_request', nullable: true })
	public optInRequest!: Date | null;

	@OneToMany(
		() => NotificationGroupMemberEntity,
		(notificationGroupMember) => notificationGroupMember.fkPhonePhoneTopic,
		{},
	)
	public notificationGroupMembers!: Array<NotificationGroupMemberEntity>;

	@ManyToOne(() => PhoneEntity, (phone) => phone.phonePhoneTopics, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__phone__id', referencedColumnName: 'id' }])
	public fkPhone!: PhoneEntity;

	@ManyToOne(
		() => PhoneTopicEntity,
		(phoneTopic) => phoneTopic.phonePhoneTopics,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__phone_topic__id', referencedColumnName: 'id' }])
	public fkPhoneTopic!: PhoneTopicEntity;
}
